import {FIELD_OPERATOR_LABELS, FieldOperator, FieldPayload, FieldType, FieldTypeAvailableOperators} from "types/filter"
import styles from "./FilterItem.module.css"
import {Checkbox, Col, Row} from "antd"
import {KlassDropdown} from "components"
import {useMemo} from "react"

export type FilterItemProps = {
    field: string
    label: string
    type: FieldType
    data?: FieldPayload
    allowedOperators?: FieldOperator[]
    customOperatorOptions?: {id: FieldOperator; name: string}[]
    children: JSX.Element
    errors?: string[]
    onChangeOperator?: (operator: FieldOperator) => void
    onChangeValue?: (value: any) => void
    isCompact?: boolean
}

export function FilterItem(props: FilterItemProps) {
    const {
        label,
        type,
        data,
        allowedOperators,
        customOperatorOptions,
        errors = [],
        children,
        onChangeOperator,
        onChangeValue,
        isCompact = false
    } = props

    const operatorOptions = useMemo(() => {
        if (type === FieldType.Flag) return []
        if (customOperatorOptions?.length) return customOperatorOptions
        const operators = allowedOperators ?? FieldTypeAvailableOperators[type]
        return operators
            .map((operator) => FIELD_OPERATOR_LABELS.find((x) => x.id === operator))
            .filter((x): x is {id: FieldOperator; name: string} => !!x)
    }, [type, allowedOperators, customOperatorOptions])

    return (
        <Row gutter={[8, 4]}>
            <Col span={isCompact ? 24 : 5}>
                <div className={styles.col}>
                    <span className={styles.title}>{label}</span>
                </div>
            </Col>
            <Col span={isCompact ? 8 : 4}>
                <div className={styles.col}>
                    {type === FieldType.Flag ? (
                        <Checkbox
                            checked={!!data?.value}
                            onChange={(e) => {
                                onChangeOperator(FieldOperator.Equal)
                                onChangeValue(e.target.checked ? true : undefined) // clear value if checkbox is unchecked
                            }}
                        />
                    ) : (
                        <KlassDropdown
                            options={operatorOptions}
                            value={operatorOptions.find((x) => x.id === data?.operator) ?? null}
                            onChange={(operator) => onChangeOperator(operator?.["id"] ?? null)}
                            error={errors.includes("operator")}
                            isClearable
                        />
                    )}
                </div>
            </Col>
            <Col span={isCompact ? 16 : 15}>{children}</Col>
        </Row>
    )
}
